import { render, staticRenderFns } from "./HandfartsContent.vue?vue&type=template&id=12c6b155"
import script from "./HandfartsContent.vue?vue&type=script&lang=js"
export * from "./HandfartsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports